import ConfigManager from '@/config/ConfigManager.js'
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';

export default {
    /**
     * @param {string} type email, sms
     * @param {string} tel
     * @param {Number} birthdate timestamp
     */
    apiResetPassword: function (type, tel, birthdate) {
        let url = ConfigManager.getApiModuleUrl() + `/profile/${tel}/forget_password_v2`;
        let params = {
            type: type,
            birthdate: birthdate,
            platform: 'web'
        };

        return BzbsApi.connectBzbsGet(url, null, params).pipe(map((res) => {
            return res.data;
        }));
    },
}
